const BalearicIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110845)">
      <path
        d="M20 0C31.0456 0 39.9999 8.95436 39.9999 20C39.9999 31.0456 31.0456 39.9999 20 39.9999C8.95436 39.9999 0 31.0456 0 20"
        fill="#FFDA44"
      />
      <path
        d="M19.5649 8.88878H36.6308C35.5071 7.21011 34.1358 5.71168 32.5694 4.44434H19.5649V8.88878Z"
        fill="#D80027"
      />
      <path
        d="M19.5649 17.7774H39.8762C39.7058 16.2363 39.3604 14.7482 38.8601 13.333H19.5649V17.7774Z"
        fill="#D80027"
      />
      <path
        d="M1.13963 26.6672H38.8603C39.3605 25.2519 39.706 23.7637 39.8764 22.2227H0.123535C0.293847 23.7638 0.639315 25.252 1.13963 26.6672Z"
        fill="#D80027"
      />
      <path
        d="M7.43046 35.5558H32.5698C34.1361 34.2885 35.5075 32.7899 36.6313 31.1113H3.36914C4.49289 32.7899 5.86414 34.2884 7.43046 35.5558Z"
        fill="#D80027"
      />
      <path
        d="M20 0C8.95436 0 -7.81243e-05 8.95436 5.11209e-10 20.0001C4.56452 20 8.95436 20.0001 20 20.0001L20 0Z"
        fill="#4A1F63"
      />
      <path
        d="M16.5216 10.4344V12.1736H15.6521V10.4344H13.913V12.1736H13.0434V8.69531H9.56515V12.1736H8.69554V10.4344H6.95648V12.1736H6.08687V10.4344H4.34766V15.6518H18.2608V10.4344H16.5216Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110845">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BalearicIslandsSvg;
